var React = require('react');

function IconInfo2 (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"10","cy":"10","r":"10","fill":"white","key":0}),React.createElement("path",{"d":"M10 0C4.4806 0 0 4.4806 0 10C0 15.5194 4.4806 20 10 20C15.5194 20 20 15.5194 20 10C20 4.4806 15.5319 0 10 0ZM9.98748 3.75469C10.6758 3.75469 11.239 4.3179 11.239 5.00626C11.239 5.69462 10.6758 6.25782 9.98748 6.25782C9.29912 6.25782 8.73592 5.69462 8.73592 5.00626C8.73592 4.3179 9.29912 3.75469 9.98748 3.75469ZM11.2641 14.9937C11.2641 15.6821 10.7009 16.2453 10.0125 16.2453C9.32416 16.2453 8.76095 15.6821 8.76095 14.9937V10.0375C8.76095 9.34919 9.32416 8.78598 10.0125 8.78598C10.7009 8.78598 11.2641 9.34919 11.2641 10.0375V14.9937Z","fill":"#222222","key":1})]);
}

IconInfo2.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = IconInfo2;

IconInfo2.default = IconInfo2;
